//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { find, first } from 'lodash'

export default {
  nuxtI18n: {
    paths: {
      br: '/produtos',
      en: '/products',
      es: '/productos'
    }
  },

  async asyncData({ $api, $cookies, params, query, app }) {
    try {
      // Get products
      const { subcategory } = params
      const { products, pagination, request } = await $api.products.showAll({
        ...query,
        sub_category: subcategory || ''
      })

      // Get search
      const { search, orderBy, order } = request

      // Get orders
      const orders = [
        {
          label: app.i18n.t('desc_relevance'),
          value: 'views',
          order: 'desc'
        },
        {
          label: app.i18n.t('asc_relevance'),
          value: 'views',
          order: 'asc'
        },
        {
          label: app.i18n.t('asc_alphabetical'),
          value: 'title',
          order: 'asc'
        },
        {
          label: app.i18n.t('desc_alphabetical'),
          value: 'title',
          order: 'desc'
        }
      ]

      // Get order
      const findOrder = find(orders, { value: orderBy, order })
      const selectedOrder = findOrder || first(orders)

      // Get list type
      const listTypeCookie = $cookies.get(
        `${process.env.STORAGE_PREFIX}productsListType`
      )
      const listType = listTypeCookie || 'columns'

      // Get categories
      const { categories: categoriesData } = await $api.products.categories()
      const categories = categoriesData.map((categoryItem) => {
        return {
          ...categoryItem,
          active: !!find(categoryItem.sub_categories, { slug: subcategory }),
          subcategories: categoryItem.sub_categories.map((subcategoryItem) => {
            return {
              ...subcategoryItem,
              active: subcategoryItem.slug === subcategory
            }
          })
        }
      })

      return {
        orders,
        selectedOrder,
        products,
        pagination,
        filter: {
          search,
          orderBy,
          order,
          listType
        },
        categories
      }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      filter: {
        search: '',
        orderBy: '',
        order: '',
        listType: ''
      },
      orders: [],
      selectedOrder: {},
      showOrder: false,
      categories: [],
      products: [],
      pagination: {}
    }
  },

  head() {
    const { title, seo } = this.activeSubcategory || {}

    return this.$helpers.seoBuilder(this, {
      staticTitle: `${this.$t('title')} ${
        seo ? ` - ${seo.title}` : title ? ` - ${title}` : ''
      }`,
      staticDescription: seo ? seo.description : null
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/produtos'
        }
      ]

      if (this.activeCategory) {
        breadcrumbs.push({
          name: this.activeCategory.title,
          path: `/produtos/${this.activeCategory.slug}`
        })

        if (this.activeSubcategory) {
          breadcrumbs.push({
            name: this.activeSubcategory.title,
            path: this.$route.fullPath
          })
        }
      }

      return breadcrumbs
    },

    activeCategory() {
      const { params } = this.$route
      const { category } = params

      if (category) {
        const categoryFounded = find(this.categories, { slug: category })
        if (categoryFounded) return categoryFounded
      }

      return null
    },

    activeSubcategory() {
      const { params } = this.$route
      const { subcategory } = params

      if (this.activeCategory && subcategory) {
        const subcategoryFounded = find(this.activeCategory.subcategories, {
          slug: subcategory
        })

        if (subcategoryFounded) return subcategoryFounded
      }

      return null
    },

    exhibitionText() {
      const { query } = this.$route
      const { page, perPage, total } = this.pagination
      const firstItem = page * perPage - (perPage - 1)
      const pageItems = Math.min(firstItem + perPage - 1, total)
      const search = query[this.$t('search')]
      const searchText = search
        ? ` para <b>"${this.$helpers.truncateText(search, 20)}"</b>`
        : ''

      return `<p>${this.$t('filter.results', { page: pageItems, total })} ${
        total === 1
          ? this.$t('filter.singular_result')
          : this.$t('filter.plural_result')
      }${searchText}</p>`
    }
  },

  watchQuery: true,

  methods: {
    onFilter() {
      const { search, order, orderBy } = this.filter
      const query = {}
      const path = '/' + this.$t('title')

      if (search) {
        query[this.$t('search')] = search
      }

      if (orderBy) {
        query[this.$t('orderBy')] = orderBy
        query[this.$t('order')] = order
      }

      this.$router.push({ path, query })
    },

    changeListType(type) {
      this.filter.listType = type
      this.$cookies.set(`${process.env.STORAGE_PREFIX}productsListType`, type)
    },

    toggleOrder() {
      this.showOrder = !this.showOrder
    },

    changeOrder(orderObj) {
      this.filter.orderBy = orderObj.value
      this.filter.order = orderObj.order
      this.onFilter()
    }
  }
}
